import { appLocale } from '@src/config/locale';

export const getOptions = (sessionId: string): { params: Record<string, string>; headers: Record<string, string> } => {
    return {
        params: { lang: appLocale.locale },
        headers: {
            'x-session-id': sessionId,
        },
    };
};
